export default {
  path: '/wellness-survey',
  component: () => import('../layouts/Dashboard/Index.vue'),
  children: [
    {
      path: '',
      name: 'wellness',
      component: () => import('../views/WellnessSurvey/PageList.vue'),
    },
    {
      path: ':companyId',
      props: true,
      component: () => import('../views/WellnessSurvey/Show/PageShow.vue'),
      children: [
        {
          path: 'company',
          name: 'wellness show',
          component: () =>
            import('../views/WellnessSurvey/Show/PageCompany.vue'),
        },
        {
          path: 'groups',
          name: 'wellness show groups',
          component: () =>
            import('../views/WellnessSurvey/Show/PageGroups.vue'),
        },
        {
          path: 'individuals',
          name: 'wellness show individuals',
          component: () =>
            import('../views/WellnessSurvey/Show/PageIndividuals.vue'),
        },
      ],
    },
  ],
}
